import React from 'react';
import 'antd/dist/antd.css';
import { Button, message } from 'antd';
import Amplify, { Auth } from 'aws-amplify';
import { Link, withRouter } from 'react-router-dom';
import { Row } from 'antd';
import { Form, Input } from 'antd';
import newLogo from '../Images/newLogo.JPG';
import { withAppContext } from '../store/contextStore';
import awsConfigure from '../Config/AwsConfig';

Amplify.configure(awsConfigure);

class ConfirmForgotPassword extends React.Component {
  state = { 
    errors: '',
    loading:false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({loading:true});
        Auth.forgotPasswordSubmit(values["username"], values["confirmationCode"], values["password"])
        .then(data => {
          message.success("Password Reset Successfully Please login with new password")
          console.log(data);
          this.props.history.push("/login");
        })
        .catch(err => {
          console.log(err);
          this.setState({
            loading: false,
            errors: err.message,
          });
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div style={{ background: "#0E4D90 0% 0% no-repeat padding-box" }} className="admin-login-form">
        <div className="login-fields" style={{height:"630px"}}>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <div style={{textAlign: 'center'}}>
                <img src={newLogo}  alt="Logo" style={{width: '50%'}}/>
              </div>
            </Row>
            <Row style={{textAlign:"center"}}>
              <span style={{color:"#73818f !important"}}>Confirm Forgot Password</span>
            </Row>
            <Form.Item label={<span className="label">Email Address</span>}>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: 'Please input your Email Address!', readOnly: true }],
                initialValue: localStorage.getItem('forgotEmail')
              })(<Input
                placeholder="Email Address"
                disabled={true}
              />)}
            </Form.Item>
            <Form.Item label={<span className="label">Confirmation Code</span>}>
              {getFieldDecorator('confirmationCode', {
                rules: [{ required: true, message: 'Please input Confirmation Code' }],
              })(<Input
                placeholder="Confirmation Code (Code sent to your email)"
              />)}
            </Form.Item>
            <Form.Item className="Formitem" label={<span className="label">Password</span>} hasFeedback>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Please input your password!', },
                { validator: this.validateToNextPassword, },],
              })(<Input.Password placeholder="*********" autoComplete="new-password" /> 
              )}
            </Form.Item>
            <Form.Item className="Formitem" label={<span className="label">Confirm Password</span>} hasFeedback>
              {getFieldDecorator('confirm', {
                rules: [{ required: true, message: 'Please confirm your password!', },
                { validator: this.compareToFirstPassword, },],
              })(<Input.Password placeholder="*********" onBlur={this.handleConfirmBlur} />)}
            </Form.Item>
              { this.state.errors &&
                  <div style={{textAlign:"center"}}><span style={{color:"#f5222d"}}>{ this.state.errors }</span></div>
                //  <Alert
                //    message={ this.state.errors }
                //    description='Error Logging in.'
                //    type='error'
                //    showIcon
                //  />
               }
            <Form.Item className="password-row">
              <Link to="/forgotPassword">Request code?</Link>
              <Button type="primary" htmlType="submit" loading={ this.state.loading } className="login-form-button">Confirm</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedNormalLoginForm = Form.create({ name: 'ConfirmForgotPassword' })(withAppContext(withRouter(ConfirmForgotPassword)));

export default WrappedNormalLoginForm;